export default {
  affiliateErrors() {
    const errors = [];
    const affiliateField = this.$v.item.affiliate;
    if (affiliateField.$dirty && affiliateField.required) {
        if (!affiliateField.$model) {
            errors.push('Afiliado obrigatório!');
        }
    }
    return errors;
  },
  depositErrors () {
    const errors = []
    if (!this.$v.item.txDeposit.$dirty) return errors
    !this.$v.item.txDeposit.minValue && errors.push('Valor inválido!')
    return errors
  },
  costsErrors () {
    const errors = []
    if (!this.$v.item.txCosts.$dirty) return errors
    !this.$v.item.txCosts.minValue && errors.push('Valor inválido!')
    return errors
  },
  drawErrors () {
    const errors = []
    if (!this.$v.item.txWithdraw.$dirty) return errors
    !this.$v.item.txWithdraw.minValue && errors.push('Valor inválido!')
    return errors
  },
}